/**
 * @fileoverview POST handler for the "/generative_ai/agent" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { generativeAiAgentCacheKeys } from "./constants";
import type { PostGenerativeAiAgentProps, GenerativeAiAgentResult } from "./types";

export const postGenerativeAiAgent = reactQueryMutationAdapter(
  generativeAiAgentCacheKeys,
  (props: PostGenerativeAiAgentProps): Promise<GenerativeAiAgentResult> => {
    return fetch("/generative_ai/agent", "POST", props, undefined, {
      // don't display a modal on fetch errors
      propagateFetchRequestError: false,
    });
  }
);
